<template>
  <div class="ebs" v-if="selected_feature">
    <!-- <div v-if="$store.getters.has_tickets_app_access">
      <a title="Tickets" @click="goto_ebs('tickets')" class="ebs-item">
        <img src="@/assets/tickets.svg" />
        <p class="count">
          <span v-if="is_loading">
            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
          </span>
          <span v-else>{{tickets_count}}</span>
        </p>
      </a>
    </div>
    <div title="Vault" style="margin-top:.5rem" v-if="$store.getters.has_vault_app_access">
      <a @click="goto_ebs('vault')" class="ebs-item">
        <img src="@/assets/vault.svg" />
        <p class="count">
          <span v-if="is_loading">
            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
          </span>
          <span v-else>{{vault_count}}</span>
        </p>
      </a>
    </div>-->
  </div>
</template>
<script>
import { mapState } from "vuex";
import _ from "lodash";
import base64 from "base-64";
import APIService from "@/api.service";

export default {
  data() {
    return {
      apiService: new APIService(),
      selected_feature: null,
      vault_count: 0,
      tickets_count: 0,
      is_loading: false
    };
  },
  computed: {
    ...mapState(["map", "token", "orthos"])
  },
  watch: {
    map: function(val) {
      if (val) {
        this.map.on("draw.selectionchange", e => {
          if (e.features.length == 1) {
            parent.postMessage({ name: "show_ebs_data", element: null }, "*");
            this.selected_feature = e.features[0];
            parent.postMessage(
              { name: "show_ebs_data", element: this.selected_feature },
              "*"
            );
            this.$root.$emit("sidebar_toggle");
            // this.get_ebs_data();
          } else {
            this.$root.$emit("sidebar_toggle");
            parent.postMessage({ name: "show_ebs_data", element: null }, "*");
            this.selected_feature = null;
          }
        });
      }
    }
  },
  methods: {
    get_organization_name(feature) {
      let group = _.find(
        this.orthos,
        f => f[0].groupUid === feature.properties.groupUid
      );
      if (group && group[0].organization) return group[0].organization.uid;
      return "";
    },
    goto_ebs(tab) {
      let action = value => {
        let centroid = turf.centroid(this.selected_feature);
        if (centroid)
          centroid = {
            lng: centroid.geometry.coordinates[0],
            lat: centroid.geometry.coordinates[1]
          };

        window.open(
          process.env.VUE_APP_EBS_FRONTEND +
            "/callback/" +
            base64.encode(
              JSON.stringify({
                ...value,
                active_tab: tab,
                name:
                  this.selected_feature.properties.name ||
                  this.selected_feature.properties.uid,
                organization: this.get_organization_name(this.selected_feature),
                centroid
              })
            ),
          "_blank"
        );
      };
      if (this.selected_feature) {
        if (
          this.selected_feature.properties.element &&
          _.isObject(this.selected_feature.properties.element)
        ) {
          action(this.selected_feature.properties.element);
        } else if (_.isString(this.selected_feature.properties.element)) {
          this.apiService
            .get_element({ url: this.selected_feature.properties.element })
            .then(res => {
              action(res.data.element);
            })
            .catch(err => {
              this.handleErrors(err);
            });
        }
      }
    },
    get_ebs_data() {
      if (
        this.selected_feature.properties.element &&
        _.isObject(this.selected_feature.properties.element)
      ) {
        this.is_loading = true;
        Promise.all([
          this.apiService.get_vault_metrics({
            query: `element=${this.selected_feature.properties.element.uid}`
          }),
          this.apiService.get_tickets_metrics({
            query: `element=${this.selected_feature.properties.element.uid}`
          })
        ])
          .then(res => {
            this.is_loading = false;
            // vault
            this.vault_count =
              (res[0].data.file ? res[0].data.file.count : 0) +
              (res[0].data.folder ? res[0].data.folder.count : 0);
            // tickets
            this.tickets_count =
              (res[1].data.assigned || 0) +
              (res[1].data.owner || 0) +
              (res[1].data.member || 0);
          })
          .catch(err => {
            this.handleErrors(err);
            this.is_loading = false;
            this.vault_count = 0;
            this.tickets_count = 0;
          });
      } else {
        this.is_loading = false;
        this.vault_count = 0;
        this.tickets_count = 0;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ebs {
  font-size: 0.7rem;
  position: fixed;
  right: 3.6rem;
  top: 2rem;
  z-index: 3800;
  div a {
    position: relative;
    background: transparent;
    padding: 1rem 0.5rem;
    border-radius: 100px;
  }
  .count {
    position: absolute;
    top: -12px;
    right: -7px;
    background: red;
    border-radius: 100px;
    padding: 2px 8px;
    color: white;
    font-size: smaller;
  }
  img {
    width: 35px;
  }
}
</style>